import { useEffect, useState } from "react";

export const STAGE_W = 1920;
export const STAGE_H = 1080;
export const TV_QUERY = "(orientation: landscape) and (min-width: 800px) and (min-height: 500px)";

const measure = () => {
  const tv = window.matchMedia(TV_QUERY).matches;
  const w = window.innerWidth;
  const h = window.innerHeight;
  const scale = Math.min(w / STAGE_W, h / STAGE_H);
  return { tv, scale, left: Math.round((w - STAGE_W * scale) / 2), top: Math.round((h - STAGE_H * scale) / 2) };
};

// Landscape screens (TV, laptop, tablet) render a fixed 1920x1080 stage scaled to fit; phones use the fluid layout.
export function useStage() {
  const [stage, setStage] = useState(measure);
  useEffect(() => {
    const update = () => setStage(measure());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);
  return stage;
}
